export class BaseSharedHelperService {
  static toShortName(firstName = '', lastName = ''): string {
    return `${(firstName[0] || '').toUpperCase()} ${(lastName[0] || '').toUpperCase()}`;
  }

  static fileNameFromHeaderValue(value: string | null, char: string): string {
    return !!value ? value.substring(value.indexOf(char) + 1) : '';
  }
}
